module.exports = __webpack_public_path__ + "assets/images/img/avatar_44.fb16b32f495bc583980dbc969c71701e.jpg";